import buttonTokensLight from '@/plugins/colors/tokens/light/sections/button'
import borderTokensLight from '@/plugins/colors/tokens/light/sections/border'
import alertTokensLight from '@/plugins/colors/tokens/light/sections/alert'
import backgroundTokensLight from '@/plugins/colors/tokens/light/sections/background'
import dropdownTokensLight from '@/plugins/colors/tokens/light/sections/dropdown'
import controlsTokensLight from '@/plugins/colors/tokens/light/sections/controls'
import iconTokensLight from '@/plugins/colors/tokens/light/sections/icon'
import inputTokensLight from '@/plugins/colors/tokens/light/sections/input'
import linkTokensLight from '@/plugins/colors/tokens/light/sections/link'
import loaderTokensLight from '@/plugins/colors/tokens/light/sections/loader'
import paginationTokensLight from '@/plugins/colors/tokens/light/sections/pagination'
import tabTokensLight from '@/plugins/colors/tokens/light/sections/tab'
import tagTokensLight from '@/plugins/colors/tokens/light/sections/tag'
import textTokensLight from '@/plugins/colors/tokens/light/sections/text'
import tooltipTokensLight from '@/plugins/colors/tokens/light/sections/tooltip'
import transparentTokensLight from '@/plugins/colors/tokens/light/sections/transparent'
import foundationTokensLight from '@/plugins/colors/tokens/light/sections/foundation'
import notificationTokensLight from '@/plugins/colors/tokens/light/sections/notifications'

// Collect all tokens for light theme and export it in one main object

export default Object.assign(
  {},
  buttonTokensLight,
  borderTokensLight,
  alertTokensLight,
  backgroundTokensLight,
  dropdownTokensLight,
  controlsTokensLight,
  iconTokensLight,
  inputTokensLight,
  linkTokensLight,
  loaderTokensLight,
  paginationTokensLight,
  tabTokensLight,
  tagTokensLight,
  textTokensLight,
  tooltipTokensLight,
  transparentTokensLight,
  tooltipTokensLight,
  foundationTokensLight,
  notificationTokensLight
)
